import React from 'react';
import { useTranslation } from 'react-i18next';

import { licensePermissionChecks } from '../../../utils/permission-check/license';
import { SubscriptionTopic } from '../../../viewer/messaging/pubsub';
import { useDialog } from '../../hooks/use-dialog';
import { useSubscribe } from '../../hooks/use-subscribe';
import { projectStateAdapter } from '../../state/project-state/project-state-adapter';
import { Button } from '../button/button';
import { CreateDesignLicenseDemoPeriodDialog } from '../create-design-license-demo-period-dialog/create-design-license-demo-period-dialog';
import { Dialog } from '../dialog/dialog';
import { InfoBox } from '../info-box/info-box';
import { List } from '../list/list';
import { Stack } from '../stack/stack';
import { DesignLicenseExpiredNotificationDialog } from './design-license-expired-notification-dialog';

export const DesignLicenseDialog = () => {
  const noAccessDialog = useDialog();
  const createDemoDialog = useDialog();
  const licenseExpiredBuyLicenseDialog = useDialog();

  useSubscribe(SubscriptionTopic.ShowDesignLicenseDialog, () => {
    if (!projectStateAdapter.getSnapshot().isCompanyAdmin) {
      noAccessDialog.show();
      return;
    }

    if (licensePermissionChecks.hasExpiredLicense('DESIGN')) {
      licenseExpiredBuyLicenseDialog.show();
      return;
    }

    createDemoDialog.show();
  });

  return (
    <>
      {noAccessDialog.render(<NoAccessDialog onClose={() => noAccessDialog.hide()} />)}

      {createDemoDialog.render(
        <CreateDesignLicenseDemoPeriodDialog onClose={() => createDemoDialog.hide()} />,
      )}

      {licenseExpiredBuyLicenseDialog.render(() => {
        return (
          <DesignLicenseExpiredNotificationDialog
            onClose={() => {
              licenseExpiredBuyLicenseDialog.hide();
            }}
          />
        );
      })}
    </>
  );
};

const NoAccessDialog = (props: { onClose: () => void }) => {
  const { t } = useTranslation();

  return (
    <Dialog width={600} onClose={props.onClose}>
      {{
        header: t('designLicenseDialog.title', { ns: 'components' }),
        content: (
          <InfoBox color="yellow">
            <Stack spacing={1}>
              <span>{t('designLicenseDialog.noAccess', { ns: 'components' })}</span>

              <span>
                {t('createDesignLicenseDemoPeriodDialog.list.openingSentence', {
                  ns: 'components',
                })}
              </span>
              <List
                items={[
                  t('createDesignLicenseDemoPeriodDialog.list.item1', { ns: 'components' }),
                  t('createDesignLicenseDemoPeriodDialog.list.importAndEdit', {
                    ns: 'components',
                  }),
                  t('createDesignLicenseDemoPeriodDialog.list.item2', { ns: 'components' }),
                  t('createDesignLicenseDemoPeriodDialog.list.item3', { ns: 'components' }),
                  t('createDesignLicenseDemoPeriodDialog.list.item4', { ns: 'components' }),
                ]}
                marker="disc"
              />
            </Stack>
          </InfoBox>
        ),
        footer: {
          right: (
            <Button variant="text" onClick={props.onClose}>
              {t('close', { ns: 'common' })}
            </Button>
          ),
        },
      }}
    </Dialog>
  );
};
